import { Link, NavLink } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useI18n } from "./I18nContext";
import NotificationBell from "./NotificationBell";
import AccountMenu from "./AccountMenu";

export default function AppShell({ children }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const roleKeys = {
    entrepreneur: "founder",
    advisor: "advisor",
    accelerator: "accelerator",
    provider: "provider",
    investor: "fundManager",
    admin: "admin",
  };
  const roleLabel = user && user.role
    ? (t(`roles.${roleKeys[user.role] || user.role}`) || user.role)
    : "";
  const hasJournalAccess = user && (user.role === "admin" || user.features?.journal_enabled === true);
  const showJournal = hasJournalAccess;

  return (
    <div className="tb-app">
      <header className="tb-app-bar">
        <Link to="/app" className="tb-app-logo" data-testid="app-logo">
          Traction<span>Board</span>
        </Link>
        <nav className="tb-app-nav" aria-label="Primary">
          {showJournal && (
            <NavLink to="/app" end data-testid="nav-journal">
              {t("nav.journal")}
            </NavLink>
          )}
          {showJournal && (
            <NavLink to="/app/memory" data-testid="nav-memory">
              {t("memory.title")}
            </NavLink>
          )}
          {showJournal && (
            <NavLink to="/app/docs" data-testid="nav-docs">
              {t("docs.title")}
            </NavLink>
          )}
          <NavLink to="/app/bookings" end={!showJournal} data-testid="nav-dashboard">
            {t("nav.dashboard")}
          </NavLink>
          <NavLink to="/app/community" data-testid="nav-community">
            {t("nav.community")}
          </NavLink>
          <NavLink to="/app/toolbox" data-testid="nav-toolbox">
            {t("nav.toolbox")}
          </NavLink>
          {user && (
            <NavLink to="/app/portfolio" data-testid="nav-portfolio">
              {t("nav.portfolio")}
            </NavLink>
          )}
        </nav>
        <div className="tb-app-bar-right">
          {user && (
            <div className="tb-user-chip" data-testid="user-chip">
              <strong>{user.name}</strong>
              {user.company && <small data-testid="user-company">{user.company}</small>}
              <small data-testid="user-role">{roleLabel}</small>
            </div>
          )}
          <NotificationBell />
          <AccountMenu />
        </div>
      </header>
      <main>{children}</main>
      <footer className="tb-app-footer" data-testid="app-footer">
        <span className="tb-muted"><small>TractionBoard v0.2.4</small></span>
      </footer>
    </div>
  );
}
